import $ from 'jquery';

export default class StaticPassword {
  constructor({ el }) {
    this.$el = $(el);
    this.$modalWrapper = $('.password-page-modal-wrapper');
    this.modalContent = this.$modalWrapper.find('.password-page-modal');
    this.openByDefault = this.$modalWrapper.find('[data-open-modal]').length;

    this._bindEvents();

    if (this.openByDefault) {
      this.openModal();
    }
  }

  _bindEvents() {
    this.events = [
      $('[data-close-modal]').on('click.password', () => this.closeModal()),
      $('.admin-login-modal').on('click.password', () => this.openModal()),
      $(window).on('resize.password', () => this.positionModal()),
    ];
  }

  closeModal() {
    if (this.$modalWrapper.hasClass('visible')) {
      this.$modalWrapper.removeClass('visible');
      this.$el.removeClass('scroll-locked');
    }
  }

  openModal() {
    this.$el.addClass('scroll-locked');
    this.positionModal();
    this.$modalWrapper.addClass('visible');
  }

  positionModal() {
    this.modalContent.css({
      marginTop: -(this.modalContent.outerHeight() / 2),
      marginLeft: -(this.modalContent.outerWidth() / 2),
    });
  }
}
